export function isAnonymisedEmail(email: string): boolean {
  return email.startsWith("anon___")
}

export function isFakeEmail(email: string) {
  if (
    email.includes("+has-left") ||
    email.includes("@clevergoose.tech") ||
    isAnonymisedEmail(email)
  ) {
    return true
  }
  return false
}
